import { render, staticRenderFns } from "./talentDialog.vue?vue&type=template&id=61f8ea4c&scoped=true"
import script from "./talentDialog.vue?vue&type=script&lang=js"
export * from "./talentDialog.vue?vue&type=script&lang=js"
import style0 from "./talentDialog.vue?vue&type=style&index=0&id=61f8ea4c&prod&lang=less&scoped=true"
import style1 from "./talentDialog.vue?vue&type=style&index=1&id=61f8ea4c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f8ea4c",
  null
  
)

export default component.exports